"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const withLoading_1 = require("../../hocs/withLoading");
const Tile_1 = __importDefault(require("./Tile"));
const styles_1 = require("@material-ui/core/styles");
const components_1 = require("@alcumus/components");
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
const FolderTile_1 = __importDefault(require("../FoldersPage/FolderTile"));
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    container: {
        padding: 0,
    },
    title: {
        lineHeight: `${theme.spacing(3)}px`,
        fontWeight: components_1.StyleVariables.fonts.weight.medium,
        paddingBottom: theme.spacing(3),
    },
}));
const ReportsTileView = ({ id, data, title, headers, emptyState, }) => {
    const classes = useStyles();
    if (!data.length) {
        return react_1.default.createElement(react_1.default.Fragment, null, emptyState);
    }
    return (react_1.default.createElement("div", { className: classes.container, "data-testid": id },
        title && (react_1.default.createElement(components_1.Text, { className: classes.title },
            title,
            " (",
            data.length,
            ")")),
        react_1.default.createElement(antd_1.Row, { gutter: [24, 36] },
            data?.map((x, index) => {
                const reportItem = {
                    id: x.id,
                    elementType: x.elementType,
                    name: x.name || 'N/A',
                    basePath: x.basePath,
                    views: x.viewCount || '--',
                    favourites: x.favoriteCount ?? 0,
                    createdBy: x.createdBy,
                    liked: x.contentFavoriteId !== null,
                    contentMetadataId: x.contentMetadataId,
                    contentFavoriteId: x.contentFavoriteId,
                    dashboards: x.dashboards,
                    looks: x.looks,
                };
                return (react_1.default.createElement(antd_1.Col, { key: index + reportItem.name, flex: "230px" }, x.elementType === reportElementTypes_1.ReportElementTypes.Folder ? (react_1.default.createElement(FolderTile_1.default, { data: reportItem, headers: headers })) : (react_1.default.createElement(Tile_1.default, { data: reportItem }))));
            }),
            react_1.default.createElement(antd_1.Col, { flex: "auto" }))));
};
exports.default = (0, withLoading_1.withSkeletonLoading)(ReportsTileView);
